import {
  ADD_USER_WITH_FORM_REQUEST,
  ADD_USER_WITH_FORM_SUCCESS,
  ADD_USER_WITH_FORM_FAILED,
  ADD_USER_WITH_FORM_RESET,
} from './actionTypes';

const initialState = {
  loading: false,
  error: '',
};

const rolesSelectReducer = (state = initialState, {
  type, error,
}) => {
  switch (type) {
    case ADD_USER_WITH_FORM_REQUEST:
      return {
        ...state,
        loading: true,
        error: '',
      };
    case ADD_USER_WITH_FORM_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case ADD_USER_WITH_FORM_FAILED:
      return {
        ...state,
        error,
        loading: false,
      };
    case ADD_USER_WITH_FORM_RESET:
      return initialState;
    default:
      return state;
  }
};

export default rolesSelectReducer;
